<template>
  <div class="box box--wrapper page-index_about">
    <div class="box-title">
      <h2>ABOUT</h2>
    </div>
    <div class="box--about page--inner">
      <div class="row">
        <div class="col-6">
          <div class="page-index_aboutImage">
            <img :src="me.img" :alt="`${me.name}`" />
          </div>
        </div>
        <div class="col-6 page-index_aboutProfile">
          <ul>
            <li><label>氏名.</label> Dupuis Jerome</li>
            <li><label>氏名 (ふりがな).</label> ジェローム ドゥプイ</li>
            <li><label>国籍.</label> フランス</li>
            <li><label>出身.</label> ベルギー国シャルルロワ市</li>
            <li><label>在住.</label> 神奈川県茅ヶ崎市</li>
            <li><label>言語.</label> フランス語、英語、日本語</li>
            <li><label>ビザ種類.</label> 永住権</li>
            <li><label>業務先.</label> 株式会社フルート @Wistant</li>
          </ul>
          <div>
          <header-nav-sns />
        </div>
        </div>
      </div>

      <div class="text--about">
        <p>
          17 years of programming experience that includes 4 years self-educated, 3 years in HEPH Condorcet university, over 1 year in TechnofuturTIC (Belgium) for a education social networking project named mENTeOS, 1 year in a small-sized Japanese company in Tokyo, 3 years in a Social Game company, 1 year for a UIUX Company, two years with Relations and currently working for Flute inc. as Front End Engineer, working mainly with React and Typescript for Wistant !<br />
          <br />
          Excellent knowledge of web development, web integration, web design and strong experience in communication & marketing<br />
          <br />
          - 2004-2008 : self-educated HTML and CSS web integration<br />
          - 2008 - 2011 : Three years at HEPH Condorcet University (Belgium) in Multimedia Write (Information technology and communication & web development).<br /><br />
          - 2011 - 2012 : TechnofuturTIC (Belgium) : 14 months for the educational project named mENTeOS.<br />
          - 1/2013 - 4/2014 : PHP Engineer for a Japanese Web Agency in Minami Azabu, Tokyo.<br />

          - 5/2014 - 1/2018 : Front End Engineer for a Social Game company Altplus Inc. located in Shibuya, Tokyo :<br />
            - Lead Front end engineer for Mobage Platform game named "Idolmaster SideM" (+3 years)<br />
            - Lead Front end engineer for IOS Webview Game named "Gumdam Area Wars" (~10 months)<br />
          - 4/2017 - current : Working intermittently as Freelance Web Engineer for Hatte inc for several homepage projects.<br />
          - 1/2018 - 2/2019 : Front End Enginner for Ohako Inc : UIUX Company, working essentially with VueJs.<br />
          - 4/2019 - 2/2021 : Front End Enginner for RELATIONS株式会社 : Working mainly with React for Wistant Service app<br />
          - 4/2021 - 2/2022 : Front End Enginner & Manager for コルデコ株式会社<br />
          - 4/2022 - current : Back with Wistant as Lead Front End Engineer with 株式会社フルート<br />
          <br />
          Languages : French (native), English business level, Japanese business level with writing and reading abilities.
        </p>

      </div>
    </div>
    <template v-if="readmore">
      <div class="box-content box-readMore">
        <router-link :to="{ name: 'PageAbout' }" class="ui-btn btn--sub1">Read more</router-link>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .box--wrapper {
    padding-bottom: 40px;
  }
  ul {
    margin: 12px 0 12px 32px;
  }
  .text--about {
    padding: 50px 70px;
  }
  @media screen and (max-width: $max-width-tablet) {
    .text--about {
      padding: 30px 20px;
    }
  }
  @media screen and (max-width: $max-width-mobile) {
    .text--about {
      padding: 0 10px;
    }
    ul {
      margin: 12px 0 12px 0;
    }
  }
</style>

<script>
import HeaderNavSns from "../../layouts/default/HeaderNavSns";
export default {
  components: {
    HeaderNavSns
  },
  props: {
    readmore: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      me: {
        name: 'Jerome Dupuis',
        work: 'フロントエンドエンジニア',
        img: './static/img/members/jerome-3.jpg'
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/common/About.vue